export enum MediaType {
  image = "image",
  video = "video",
}

export type Story = {
  id: string
  createdAt: Date
  perfilId: string
  mediaFilename: string
  mediaType: MediaType.image | MediaType.video
  shortMessage?: string | null
  expiresAt: Date
  perfil: {
    id: string
    nome: string
    foto_filename?: string | null
    slug: string
    cidade?: string
    especialidade?: string[]
    telefone_whatsapp?: string
  }
}